module.exports = __webpack_public_path__ + "img/kgf-donghaeng-logo.8ce05a62.svg";